import { Modal, Button, Form, Checkbox, Flex, Typography } from 'antd';
import React, { useEffect } from 'react';
import Cookies from 'js-cookie'
import { useTranslation } from 'react-i18next';

const rtllSettings = { expires: 365 }

const liStyle = {
  marginBottom: "5px"
}
export function ConfirmCalculateModal(props) {
  // var input = document.getElementById("myInput")
  const { t } = useTranslation();

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (props.isConfirmOpen && event.key === 'Enter') {
        props.submitForm();
      }
    };

    window.addEventListener('keydown', handleKeyPress);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, [props.isConfirmOpen, props.submitForm]);


  return (
    <Modal
      title={t('60001')/* Disclaimer */}
      // description="Are you sure you want to calculate?" // placement="topLeft"
      open={props.isConfirmOpen}
      onOk={props.submitForm} // confirmLoading={isSubmitting}
      onCancel={props.handleCancelPopConfirm}
      width={"60%"}
    >
      {/* Are you sure you want to calculate */}


      {/* <Typography.Text type='secondary'>
          RealTimeLSS is for informational purposes only and does not provide legal, technical, or professional advice. For safety compliance decisions, 
          consult a certified Lasermet Laser Safety Officer or another qualified professional. Click here to view the full  <a href="/terms-and-conditions" target="_blank" rel="noreferrer">terms and conditions</a>, or click <a href='https://www.lasermet.com/laser-safety-services/laser-protection-adviser/' target="_blank" rel="noreferrer">here</a> to request a consultation with a certified Lasermet Laser Safety Officer
        </Typography.Text> */}
      <Typography.Paragraph>

        {t('60002')} {/*The laser safety parameter calculation tool provided on this website is designed to assist users in calculating laser safety parameters based on the IEC 60825-1 standard. While we strive to ensure the accuracy and reliability of the calculations, the tool is provided "as is" without any guarantees or warranties of any kind, either express or implied.*/}

      </Typography.Paragraph>
      <Typography.Paragraph>
        {t('60003')} {/*  Accuracy and Limitations: */}
      </Typography.Paragraph>
      <ol>
        <li style={liStyle}>
          <strong>{t('60004') /*Accuracy*/}</strong> {t('60005') /*This tool is desigend....*/}
        </li>
        <li style={liStyle}>
          <strong>{t('60006') /*No Professional Advice:*/}</strong> {t('60007') /*The calculations and information provided by this tool */}
        </li>
        <li style={liStyle}>
          <strong>{t('60008') /*Limitation of Liability: */}</strong> {t('60009') /* In no event shall Lasermet, its affiliates, */}

        </li>
        <li style={liStyle}>
          <strong>{t('60010') /*User Responsibility:*/}</strong> {t('60011') /*Users are responsible for verifying the results obtained */}

        </li>
      </ol>

      <Typography.Text type='secondary'>
        {t('60012') /*By using this tool, you acknowledge and agree to the terms of this disclaimer and accept full responsibility for any risks associated with its use. */}
      </Typography.Text>


      <Flex justify='right' style={{ marginBottom: "-20px" }}>
        <Form.Item
          label={t('10128') /*Dont show again}*/}>
          <Checkbox
            onChange={(e) => {
              if (Cookies.get('RTLSS_SETTINGS')) {

                if (e.target.checked) {
                  Cookies.set('RTLSS_SETTINGS', JSON.stringify({ ...JSON.parse(Cookies.get('RTLSS_SETTINGS')), hide_confirmation: true }), rtllSettings)
                } else {
                  Cookies.set('RTLSS_SETTINGS', JSON.stringify({ ...JSON.parse(Cookies.get('RTLSS_SETTINGS')), hide_confirmation: false }), rtllSettings)
                }
              } else {

                Cookies.set('RTLSS_SETTINGS', JSON.stringify({}), rtllSettings)
              }

            }} />
        </Form.Item>
      </Flex>

    </Modal>);
}
